function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "-1 -1 11 11"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#current",
  stroke: "#current",
  strokeLinecap: "round",
  strokeWidth: "1.5",
  d: "M0 0l9 9M0 9l9-9"
})));